import { API_PREFIX } from '@/assets/js/configs';

export default function getMetaTableApi(tableId) {
  return `${API_PREFIX}/meta_tables/${tableId}`;
}
